import { business, fullAddress } from './business';

const lastUpdated = 'August 12, 2026';

export const policies = {
  privacy: {
    title: 'Privacy Policy',
    updated: lastUpdated,
    sections: [
      {
        heading: 'Who We Are',
        body: `This website is operated by ${business.legalName}, trading as "${business.tradeName}" (${business.constitution}), registered under GSTIN ${business.gstin}, with its principal place of business at ${fullAddress}.`
      },
      {
        heading: 'Information We Collect',
        body: `We only collect information you choose to give us through the "Get a Free Quote" contact form on this site: your name, email address, company name, and the message/requirements you enter. We do not use tracking pixels, ad networks, or third-party analytics on this site.`
      },
      {
        heading: 'How We Use Your Information',
        body: `Information submitted through the contact form is used solely to respond to your enquiry, prepare quotations, and communicate about your order. We do not sell, rent, or share your information with third parties for marketing purposes.`
      },
      {
        heading: 'Data Storage & Retention',
        body: `Enquiries submitted via this website are sent directly to our business email (${business.email}) and retained only as long as needed to service your enquiry or as required for our business/tax records under Indian law.`
      },
      {
        heading: 'Your Rights',
        body: `You may request access to, correction of, or deletion of any personal information you have shared with us by writing to ${business.email}. We will respond within a reasonable time.`
      },
      {
        heading: 'Contact Us',
        body: `For any privacy-related questions, contact us at ${business.email} or write to us at ${fullAddress}.`
      }
    ]
  },
  terms: {
    title: 'Terms of Service',
    updated: lastUpdated,
    sections: [
      {
        heading: 'About These Terms',
        body: `These Terms of Service govern your use of this website and any enquiry, quotation, or order placed with ${business.tradeName} (${business.legalName}, ${business.constitution}, GSTIN ${business.gstin}). By using this site or submitting an enquiry, you agree to these terms.`
      },
      {
        heading: 'Products & Services',
        body: `We offer apparel and clothing (including T-shirts and custom garments), textile fabrics, custom manufacturing and private-label work, and wholesale/bulk textile trading. Product availability, specifications, and pricing are confirmed individually for each enquiry and are subject to change without prior notice.`
      },
      {
        heading: 'Quotations & Orders',
        body: `All prices, minimum order quantities, and delivery timelines mentioned during an enquiry are estimates until confirmed in writing. An order is considered confirmed only after both parties agree on specifications, pricing, and payment terms.`
      },
      {
        heading: 'Payment',
        body: `Payment terms (including any advance payment) will be communicated and agreed upon at the time of order confirmation for each individual order.`
      },
      {
        heading: 'Delivery',
        body: `Delivery timelines depend on order quantity, customization, and destination, and will be communicated at the time of order confirmation. We are not liable for delays caused by courier/logistics partners or events beyond our reasonable control.`
      },
      {
        heading: 'Limitation of Liability',
        body: `We take reasonable care to ensure product quality and accurate information on this website, but we do not guarantee that the website will be error-free or uninterrupted. To the extent permitted by law, our liability is limited to the value of the specific order in question.`
      },
      {
        heading: 'Governing Law',
        body: `These terms are governed by the laws of India, and any disputes will be subject to the jurisdiction of the courts in Patna, Bihar.`
      },
      {
        heading: 'Contact',
        body: `Questions about these terms can be sent to ${business.email}.`
      }
    ]
  },
  cookies: {
    title: 'Cookie Policy',
    updated: lastUpdated,
    sections: [
      {
        heading: 'Our Use of Cookies',
        body: `This website does not use advertising or third-party tracking cookies. We do not run analytics scripts, retargeting pixels, or ad-network cookies on this site.`
      },
      {
        heading: 'Essential Local Storage',
        body: `The site may use your browser's local storage purely for basic functionality (such as remembering your form entries while you complete an enquiry). This information stays in your browser and is not transmitted to us until you submit the form.`
      },
      {
        heading: 'Changes to This Policy',
        body: `If we add analytics or marketing cookies in the future, this policy will be updated accordingly and the update date below will change.`
      },
      {
        heading: 'Contact',
        body: `Questions about this cookie policy can be sent to ${business.email}.`
      }
    ]
  }
};
